import { ThunderboltFilled } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

export function UpgradeBanner() {
  const navigate = useNavigate();

  return (
    <div className="mb-6 sm:mb-8 bg-gradient-to-r from-[#FFA500] via-[#FFB84D] to-[#FFD700] rounded-xl shadow-lg overflow-hidden">
      <div className="px-4 sm:px-8 py-6 sm:py-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <ThunderboltFilled />
            </div>
            <div>
              <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-1">
                Auto-Sync Expenses With Your Bank Account
              </h3>

              <p className="text-sm sm:text-base text-gray-800">
                Upgrade to automatically sync your transactions from your bank
                or credit card.
                <strong>$1.99 per account</strong> per month.
              </p>
            </div>
          </div>

          <div className="flex-shrink-0">
            <Button
              className="bg-gray-900 text-white hover:bg-gray-800 font-semibold text-sm sm:text-base px-6 sm:px-8 py-2 sm:py-3 h-auto whitespace-nowrap"
              onClick={() => navigate(`/subscriptions`)}
            >
              View Plans
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
